import React from 'react';

import IChatOptions from '../../../../interfaces/IChatOptions';
import { Button, FlexContainer, Label } from '../../styled';
import { ExitButtonContainer } from './ChatExitStyles';

interface IChatExitProps {
  onCancel: () => void;
  onExit: () => void;
  options: IChatOptions;
}

const ChatExit = (props: IChatExitProps) => {
  const { onCancel, onExit } = props;
  return (
    <ExitButtonContainer>
      <Label>Are you sure you want to end this chat?</Label>
      <br />
      <FlexContainer spaceBetween data-testid='cancel-chat'>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onExit} filled data-testid='end-chat'>
          End
        </Button>
      </FlexContainer>
    </ExitButtonContainer>
  );
};

export default ChatExit;
